import {
  ChangeDetectionStrategy,
  Component,
  AfterViewInit,
  signal,
  output,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { InputFieldMaterialComponent } from '../../../../shared/components/input-field-material/input-field-material.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { ChipComponent } from '../../../../shared/components/chip/chip.component';

@Component({
  selector: 'app-form-leaflet-draw',
  imports: [
    InputFieldMaterialComponent,
    FormsModule,
    ReactiveFormsModule,
    ChipComponent,
  ],
  templateUrl: './form-leaflet-draw.component.html',
  styleUrl: './form-leaflet-draw.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLeafletDrawComponent implements AfterViewInit, OnDestroy {
  @Output() isValidForm: EventEmitter<boolean> = new EventEmitter<boolean>();
  nombreParcela: FormControl = new FormControl(
    { value: '', disabled: false },
    Validators.required
  );
  referenciaCatastral: FormControl = new FormControl(
    { value: '', disabled: false },
    Validators.required
  );
  formGroup: FormGroup;

  getFormValue(): any {
    return {
      name: this.formGroup.value['nombreParcela'],
      ref_catastral: this.formGroup.value['referenciaCatastral'],
    };
  }

  constructor(private formBuilder: FormBuilder) {
    this.formGroup = this.formBuilder.group({
      nombreParcela: this.nombreParcela,
      referenciaCatastral: this.referenciaCatastral,
    });
  }

  ngAfterViewInit(): void {
    this.formGroup.valueChanges.subscribe(_ => {
      this.isValidForm.next(this.formGroup.valid);
    });
  }

  ngOnDestroy(): void {
    this.formGroup.reset();
  }
}
